import React, { useEffect, useState } from "react";
import classes from "./Meeting.module.css"
import Button from "../../../Button/Button";
import PackageIcon from "../../../../img/white-package.png"
import FireIcon from "../../../../img/white-fire.png"
import partnersImg from "../../../../img/partners.png"
import sensorMeeting from "../../../../img/sensorMeeting.png"
import {BrowserRouter as Router, NavLink} from 'react-router-dom'

const Meeting = () => {
    return (
        // Стандартная страница
        <div className={classes.Meeting}>
            <div className={classes.contentMeeting}>
                    <div className={classes.textMeet1}>
                        <h1>ЭнергоТестСервис</h1>
                        <h2>Производство современных средств измерения и автоматизации</h2>
                        <NavLink onClick={()=>{window.scrollTo(0,0)}} to="/Products"><Button title="Ознакомиться" padding="12px 31px 11px 31px" borderRadius="15px"/></NavLink>
                        <div className={classes.mobMeet}>
                            <div className={classes.achivMob}>
                                <span className={classes.aM1}><img src={FireIcon}/><span>3000+ заказов</span></span>
                            </div>
                            <div className={classes.mobMeetCont}>
                                <h3>Производство современных средств измерения и автоматизации</h3>
                                <NavLink onClick={()=>{window.scrollTo(0,0)}} to="/Products"><img src={PackageIcon}/></NavLink>
                            </div>  
                        </div>
                    </div>
                <div className={classes.achivments}>
                    <div>
                        <h3>3000+</h3>
                        <h4>Заказов</h4>
                    </div>
                    <div>
                        <h3>10000+</h3>
                        <h4>Обращений</h4>
                    </div>
                    <div>
                        <h3>50+</h3>
                        <h4>Сотрудников</h4>
                    </div>
                    <div className={classes.partners}>
                        <img src={partnersImg} alt="Партнёры" />
                        <h4>Партнёры</h4>
                    </div>
                </div>
                <div className={classes.sens}>
                    <img src={sensorMeeting} alt="Сенсор"/>
                </div>
            </div>
        </div>
    )
}

export default Meeting